jQuery(document).ready(function () {
  if ($(".fichesmetiersmall").length > 0) {
    $('.fichesmetiersmall_list').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true
    });
  }
});
